import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
//import util from 'util';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router';
import "react-datepicker/dist/react-datepicker.css"
import moment from 'moment';
import Modal from 'react-modal';
import spinner from '../Images/LINE_spinner_light.svg';
import constClass from '../../Constants/Constants';

const BonusPoint = (props) => {
  const { user } = props;
  const { siteId, mallId } = useParams();
  const [fileRead, setFileRead] = useState(false);
  const [bonusPointListData, setBonusPointListData] = useState(null);
  const [bonusPointId, setBonusPointId] = useState(null);
  const [csvCount, setCsvCount] = useState(null);
  const [page, setPage] = useState(0);
  const [confirm, setConfirm] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();
  const pageCount = 20;

  const modalConfirmStyle = {
    overlay: {
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: "rgba(0,0,0,0.5)"
    },
    content: {
      left: '10%',
      right: '10%',
      top: '15%',
      bottom: 'auto',
      padding: "0px",
      maxHeight: "80%",
      width: "80%",
      overflowX: "hidden",
      pointerEvents: "auto",
      backgroundClip: "padding-box",
      border: "1px rgba(0,0,0,.2)",
      overflow: "visible",
    }
  };
  const refreshData = useCallback(async () => {
    //トークンを取得
    const jwt = localStorage.getItem('jwt');
    const bonusdata = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/bonuspoint/search`, { site_id: siteId, mall_id: mallId, page, count: pageCount }, { headers: { Authorization: `Bearer ${jwt}` } })).data;
    setBonusPointListData(bonusdata);
  }, [siteId, mallId, page, pageCount]);

  const BonusPointUploadUrl = async (filename) => {
    console.log("BonusPointUploadUrl")
    const jwt = localStorage.getItem('jwt');
    const params = {
      site_id: siteId,
      mall_id: mallId,
      file_name: filename,
      user_id: user.userId
    };
    console.log({ params })
    // URL取得
    const res = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/bonuspoint/uploadurl/`, params, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    }));
    console.log({ res })
    var uploadurl = null;
    if (res.data && res.data.bonuspoint && res.data.bonuspoint.bonus_point_id) {
      setBonusPointId(res.data.bonuspoint.bonus_point_id);
      uploadurl = res.data.url;
    }
    return uploadurl;

  }
  const ReadFile = async (bonus_point_id) => {
    console.log("ReadFile", bonus_point_id);

    setFileRead(true);
    var message = null;
    try {
      const jwt = localStorage.getItem('jwt');
      const params = {
        site_id: siteId,
        bonus_point_id,
        user_id: user.userId
      }
      const res = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/bonuspoint/import/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      }));
      console.log(res)
      if (res && res.data && res.data.msg) {
        message = res.data.msg || ""
      } else
        if (res && res.data && res.data.result && res.data.data) {
          const bonuspoint = res.data.data
          message = `${bonuspoint.data_count}件アップロードしました。`;
        }
    } catch (error) {
      console.log(error)
    } finally {
      await refreshData();
      setConfirm(false);
      if (message) window.alert(message);
      setFileRead(false);
      setLockData(false)
    }
  }
  const handleCreate = async () => {
    setLockData(true);
    try {
      const jwt = localStorage.getItem('jwt');
      const params = {
        site_id: siteId,
        mall_id: mallId,
        user_id: user.userId
      }
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/bonuspoint/create`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      });
      if (res && res.data && res.data.result) {
        setBonusPointId(res.data.data.bonus_point_id);
        setPage("upload");
        setConfirm(true);
      } else {
        window.alert("エラーが発生しました")
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLockData(false);
    }

  }
  // ファイル選択
  const handleUploadFile = async (e) => {
    console.log("handleUploadFile")
    const value = e.target.files[0];
    if (lockData || fileRead) {
      window.alert('現在アップロード中です。お待ちください');
      return "";
    }
    var reader = new FileReader();
    setLockData(true);
    reader.onloadend = async () => {
      var filename = value.name; //ファイル名
      if (filename.slice((filename.lastIndexOf('.')) + 1) !== "csv") { // ファイル形式チェック
        window.alert("csv形式のファイルをアップロードしてください");
        setLockData(false);
        return;
      }
      try {
        const uploadurl = await BonusPointUploadUrl(filename);
        if (!uploadurl) throw new Error('アップロードURL取得に失敗しました');
        const proxy = (process.env.NODE_ENV !== "dev") ? false : { protocol: "http", host: "proxy.nnr.co.jp", port: "8080" }
        const res = await axios.put(uploadurl, value,
          {
            'content-type': 'text/csv',
            'x-amz-acl': 'bucket-owner-full-control',
            'proxy': proxy
          }
        );
        console.log(res)
        if (res && res.status) {
          await ReadFile(bonusPointId);
        }
      } catch (e) {
        console.log(e)
        window.alert("アップロードに失敗しました");
        setLockData(false);
        return;
      }

      setLockData(false);
    }
    reader.readAsArrayBuffer(value);
  }

  const handleRegistClick = async (data) => {
    //トークンを取得
    try {
      setLockData(true);
      if (!window.confirm(`[ID:${data.bonus_point_id}(${data.data_count}件)]をポイント付与します。\n※ポイント付与は取り消せません。\nよろしいですか？`)) {
        return;
      }
      const jwt = localStorage.getItem('jwt');
      const params = {
        site_id: siteId,
        mall_id: mallId,
        bonus_point_id: data.bonus_point_id,
        upd_date: data.upd_date,
        "user_id": user.userId
      }
      const res = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/bonuspoint/register`, params, { headers: { Authorization: `Bearer ${jwt}` } })).data;
      if (res.result) {
        addToast("ポイント付与が完了しました", { appearance: 'info', autoDismiss: true });
      } else {
        addToast(res.msg ? res.msg : "ポイント付与に失敗しました", { appearance: 'error', autoDismiss: true });
      }
    } catch (error) {
      console.log(error)
      addToast("ポイント付与に失敗しました", { appearance: 'error', autoDismiss: true });
    } finally {
      await refreshData();
      setLockData(true);
    }
  }
  const handleDeleteClick = async (data) => {
    //トークンを取得
    try {
      setLockData(true);

      const jwt = localStorage.getItem('jwt');
      const res = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/bonuspoint/delete`, { site_id: siteId, bonus_point_id: data.bonus_point_id, upd_date: data.upd_date }, { headers: { Authorization: `Bearer ${jwt}` } })).data;
      console.log(res)
      if (res.result) {
        addToast("削除しました", { appearance: 'info', autoDismiss: true });
      } else {
        addToast("削除に失敗しました", { appearance: 'error', autoDismiss: true });
      }
    } catch (error) {
      console.log(error);
      addToast("削除に失敗しました", { appearance: 'error', autoDismiss: true });
    } finally {
      refreshData();
      setLockData(false);
    }
  }
  const handleCsvClick = async (data) => {
    //トークンを取得
    setLockData(true);
    try {
      setPage("download");
      setConfirm(true);
      const jwt = localStorage.getItem('jwt');
      setBonusPointId(data.bonus_point_id);
      const params = {
        site_id: siteId,
        mall_id: mallId,
        bonus_point_id: data.bonus_point_id,
        user_id: user.userId
      };
      setCsvCount(null);
      setDownloadUrl(null);
      // DB取得
      const res = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/bonuspoint/export/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      }));
      const resdata = res.data;
      if (resdata.result) {
        setCsvCount(resdata.data.count);
        setDownloadUrl(resdata.data.url);
      }

    } catch (error) {
      console.log(error)
    } finally {
      setLockData(false);
    }
  }
  const renderCsvButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleCsvClick(data)}>
        ダウンロード
      </button>
    )
  }
  const renderRegistButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleRegistClick(data)}>
        ポイント反映
      </button>
    )
  }
  const renderDeleteButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }
  const renderCreateButton = () => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={handleCreate}>
        ファイルアップロード
      </button>
    )
  }
  useEffect(() => {
    refreshData();
  }, [refreshData]);


  const renderList = () => {
    return (
      <div className="row mb-3 p-0">
        <div className="col-12 p-0">
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  ID
                </td>
                <td className="text-center align-middle">
                  取込日付
                </td>
                <td className="text-center align-middle">
                  取込ファイル名
                </td>
                <td className="text-center align-middle">
                  取込件数
                </td>
                <td className="text-center align-middle">
                  反映日時
                </td>
                <td className="text-center align-middle">
                  反映件数
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {bonusPointListData.filter(x => x.file_name).map((data, idx) => (
                <tr key={idx}>
                  {/* ID */}
                  <td className="text-center align-middle">
                    {data.bonus_point_id}
                  </td>
                  {/* 取込日付 */}
                  <td className="text-center align-middle">
                    {moment(data.import_date).format("YYYY/MM/DD HH:mm")}
                  </td>
                  <td className="text-center align-middle">
                    {data.file_name}
                  </td>
                  <td className="text-center align-middle">
                    {data.data_count}
                  </td>
                  <td className="text-center align-middle">
                    {data.regist_flag === constClass.FLAG.ON && moment(data.point_date).format('YYYY/MM/DD HH:mm')}
                  </td>
                  <td className="text-center align-middle">
                    {data.regist_flag === constClass.FLAG.ON && data.regist_count}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderCsvButton(data)}
                    {(data.regist_flag === constClass.FLAG.OFF && mallId.toString() === user.mallId.toString() && user.userClass === constClass.USER_CLASS.MANAGERMALL) && renderRegistButton(data)}
                    {data.regist_flag !== constClass.FLAG.ON && renderDeleteButton(data)}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  const renderModal = () => {
    return (
      <div>
        <Modal isOpen={confirm} style={modalConfirmStyle} onRequestClose={() => setConfirm(false)}>
          <div className="">
            <div className="modal-header">
              {page === "download" ? "CSVダウンロード" : "CSVアップロード"}
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => setConfirm(false)}><span aria-hidden="true">&times;</span></button>
            </div>
            <div className="modal-body">
              {page === "download" ?
                <React.Fragment>
                  {(downloadUrl && csvCount > 0) &&
                    <div className='row'>
                      <div className='col text-center'><a href={downloadUrl} target="_blank" rel="noreferrer" className="btn btn-primary text-white" onClick={() => { setConfirm(false) }}>ダウンロード({csvCount}件)</a>
                      </div></div>
                  }
                  {(downloadUrl && csvCount === 0) &&
                    <div className="p-1">対象のデータが取得できませんでした。</div>
                  }
                  {(!downloadUrl && !csvCount) &&
                    <div className='row'>
                      <div className='col-auto'><img className="spinner" alt="読み込み中..." src={spinner} style={{ width: "2rem" }} /></div>
                      <div className='col'>現在取得中</div>
                    </div>
                  }
                </React.Fragment>
                :
                <React.Fragment>
                  {(lockData) ?
                    <div className='row'>
                      <div className='col-auto'><img className="spinner" alt="読み込み中..." src={spinner} style={{ width: "2rem" }} /></div>
                      <div className='col'>現在取込中</div>
                    </div>
                    :
                    <div className="row pt-3">
                      <div className='col-4 text-right'>CSVファイルを選択してください：</div>
                      <div className='col-8'><input type="file" onChange={handleUploadFile} /></div>
                    </div>
                  }
                </React.Fragment>
              }
            </div>
          </div>
        </Modal>
      </div>
    )
  }
  return (
    <div className="container">
      {bonusPointListData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {bonusPointListData !== null && <div className="row"><div className="col-12 m-3 text-right">{renderCreateButton()}</div></div>}
      {bonusPointListData !== null && (renderList())}
      {renderModal()}
    </div>
  )
}

export default BonusPoint;